import React, {useContext} from 'react'
import RolesFunctionHead from "./RolesFunctionHead"
import RolesFunctionBody from "./RolesFunctionBody"
import {Spin} from "antd"
import {SettingRoleContext} from "../../context/SettingRoleContext";

function RolesFunctionTable(props) {
    const SettingRolePageContext = useContext(SettingRoleContext)
    const {listRolesFunction, loadingFunc} = SettingRolePageContext

    return <div className="LeadTable">
        <Spin spinning={loadingFunc} tip="Đang lấy dữ liệu...">
            <table className="table">
                <RolesFunctionHead {...props}/>
                <RolesFunctionBody loading={loadingFunc} listRoles={listRolesFunction} {...props}/>
            </table>
        </Spin>
    </div>
}

export default RolesFunctionTable
